import axios from 'axios'
import store from '../store'
import router from '../router'

const VUEX_AUTH = 'auth'

axios.defaults.baseURL = process.env.VUE_APP_URL || 'http://your-market.localhost/api'

// Request interceptor
axios.interceptors.request.use(request => {
    const token = store.getters[`${VUEX_AUTH}/obtenerToken`]
    if (token) request.headers.common['Authorization'] = `Bearer ${token}`

    const locale = store.getters['lang/locale']
    if (locale) request.headers.common['Accept-Language'] = locale

    return request
})

// Response interceptor
axios.interceptors.response.use(response => response, error => {
    const { status } = error.response

    if (status >= 500) console.error(error)

    if (status === 401){
        store.commit(`${VUEX_AUTH}/CERRAR_SESION`)
        router.push({ name: 'login.form.admin' })
    }

    return Promise.reject(error)
})
